
import { defineComponent } from 'vue'
import { usePackageModule } from '@/modules/packages'
import { useRoute, useRouter } from 'vue-router'
import PackagesEditPackageForm from '@/components/packages/forms/edit-package.vue'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import { PackagesRouteNames } from '@/router/routes-names'
import ConfirmDeletionDialog from '@/components/_shared/dialogs/confirm-deletion-dialog.vue'

export default defineComponent({
    name: 'view-packages-edit-package',
    components: { PackagesEditPackageForm },
    async setup () {
        const $q = useQuasar()
        const { getPackage, deletePackage } = usePackageModule()
        const route = useRoute()
        const router = useRouter()

        const packageCode = route.params.code as string
        const singlePackage = await getPackage(packageCode)

        async function onDeletePackage () {
            $q.dialog({
                component: ConfirmDeletionDialog,
                componentProps: {
                    entityType: 'package',
                    identifier: singlePackage.code,
                    deleteCallback: async () => {
                        await deletePackage(singlePackage.id).then(() => router.push({ name: PackagesRouteNames.LIST, query: { page: route.query.page } }))
                    }
                }
            })
        }

        return {
            onDeletePackage,
            singlePackage,
            packageCode
        }
    }
})
